//
// Generated class DeliveryPostalCode
//

/// <reference path="DeliveryPostalCode_ManagedObject.ts" />

class DeliveryPostalCode extends DeliveryPostalCode_ManagedObject
{
}
